// Non-translatable configuration (icons, colors, images) indexed to match the
// order of the arrays in the locale JSON files.
import {
  Sun, Users2, HeartHandshake, Moon, Scale, Wind, Sprout, Baby, GraduationCap,
} from 'lucide-react';

export const images = {
  hero: 'https://customer-assets.emergentagent.com/job_talk-scheduler-2/artifacts/okixmvu0_ChatGPT%20Image%20Jul%2010%2C%202026%2C%2008_38_44%20PM.png',
  testimonial: 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/ab5026c33ed87936_WhatsApp%20Image%202026-10-20%20at%209.58.19%20PM.jpeg',
  desk: 'https://customer-assets.emergentagent.com/job_talk-scheduler-2/artifacts/tyw9ak3n_Photo4.png',
  cozy: 'https://customer-assets.emergentagent.com/job_talk-scheduler-2/artifacts/zos24g79_Photo2.png',
  cta: 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/9rmay2ys_photo%20maman.png',
  book: 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/lar1643u_PHOTO-2026-07-16-14-27-05.jpg',
  expMontreal: 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/fwkgewyn_940e3a64-c505-4c09-ab24-906cdf432d5b%20%281%29.JPG',
  expBenin: 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/be8e941f822ddaff_Photo%20benin.jpg',
};

export const walkInVideo = 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/c45b06583c18d3a7_Walk-in%20veideo.MP4';

export const bookPresaleUrl = 'https://website-builder-2158.preview.emergentagent.com/?utm_source=share';

// object-position per gallery image so subjects stay centered
export const galleryPositions = ['50% 0%', '50% 30%', '50% 36%', '50% 30%', '50% 25%', '50% 0%'];

export const galleryImages = [
  'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/2e66f71e407229b5_905c497c-0153-4f01-8b2e-75d50e1a1bf7.JPG',
  'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/7e9c65909dfc9cef_e04e8f10-a06c-4eca-ab74-696db38e74f2.JPG',
  'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/02a3965e9b81790d_8ca95e32-1159-4e16-a480-ae13d41400a5.JPG',
  'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/890da1f45b5d1540_WhatsApp%20Image%202026-10-18%20at%208.25.20%20PM.jpeg',
  'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/325d113cc97ddc30_WhatsApp%20Image%202026-10-18%20at%208.25.20%20PM%20%281%29.jpeg',
  'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/ffbbd5dae00de72f_Screenshot%202026-10-18%20at%2010.49.21%E2%80%AFPM.PNG',
];

export const testimonialVideo = 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/yvkuipff_Kate%20Testimonial.mp4';

export const testimonialVideo2 = 'https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/7ae7678dd93ee485_Sherry-Lunn%20Bursey.MP4';

// impact features (5) -> icon names resolved via iconMap in the page
export const impactIcons = ['Users', 'Lightbulb', 'Heart', 'MessageCircle', 'Star'];

// speaking topics (6) -> icon component + colors, same order as t.topics.items
export const topicMeta = [
  { icon: Scale, color: 'var(--coral)', titleColor: 'var(--navy)' },
  { icon: Users2, color: 'var(--coral)', titleColor: 'var(--navy)' },
  { icon: HeartHandshake, color: 'var(--teal)', titleColor: 'var(--coral)' },
  { icon: Moon, color: 'var(--navy)', titleColor: 'var(--coral)' },
  { icon: Wind, color: 'var(--gold)', titleColor: 'var(--coral)' },
  { icon: Sprout, color: 'var(--teal)', titleColor: 'var(--navy)' },
  { icon: Baby, color: 'var(--coral)', titleColor: 'var(--navy)' },
  { icon: GraduationCap, color: 'var(--gold)', titleColor: 'var(--navy)' },
];

// credentials (4) -> icon names, same order as t.credentials.items
export const credentialIcons = ['BadgeCheck', 'GraduationCap', 'Users', 'Award'];

// trust badges (4) -> icon names, same order as t.trust
export const trustIcons = ['Users', 'Heart', 'Award', 'Globe'];

// thank-you steps (4) -> icon name + circle color
export const stepMeta = [
  { icon: 'Mail', color: 'var(--navy)' },
  { icon: 'Clock', color: 'var(--coral)' },
  { icon: 'MessageCircle', color: 'var(--gold)' },
  { icon: 'Heart', color: 'var(--teal)' },
];

// socials (3) -> icon name + color
export const socialMeta = [
  { icon: 'Instagram', color: 'var(--coral)' },
  { icon: 'Facebook', color: 'var(--footer-blue)' },
  { icon: 'Linkedin', color: 'var(--navy)' },
];

// booking trust row (3) -> icon + color
export const bookingTrustMeta = [
  { icon: 'Lock', color: 'var(--gold)' },
  { icon: 'Clock', color: 'var(--gold)' },
  { icon: 'Heart', color: 'var(--coral)' },
];
